import { Button } from '@/components/Button'
import {
  Section,
  SectionItem,
} from '@/features/jobs/info-gathering/components/Section'

export interface SpousalProfileProps {
  isLoading: boolean
  isEditable: boolean
  onEdit?: () => void
  fullName?: string
  dateOfBirth?: string
  occupation?: string
  email?: string
  personalTaxpayerIdentificationNumber?: string
  maskedPersonalTaxpayerIdentificationNumber?: string
  editButtonTestId?: string
}

export function SpousalProfile({
  isLoading,
  isEditable,
  onEdit,
  fullName,
  dateOfBirth,
  occupation,
  email,
  personalTaxpayerIdentificationNumber,
  maskedPersonalTaxpayerIdentificationNumber,
  editButtonTestId,
}: SpousalProfileProps) {
  return (
    <div>
      <Section
        title="Spousal Information"
        bordered
        isLoading={isLoading}
        actions={
          isEditable ? (
            <Button
              label="Edit"
              variant="text"
              onPress={onEdit}
              testId={editButtonTestId}
            />
          ) : undefined
        }
      >
        <SectionItem label="Name" value={fullName} isSensitive />

        <SectionItem label="Date of birth" value={dateOfBirth} isSensitive />

        <SectionItem label="Occupation" value={occupation} isSensitive />

        {/* Spouses only provide an email; the rest of the contact info is
            collected to keep the API shape consistent with other profiles. */}
        {email && (
          <SectionItem label="Email address" value={email} isSensitive />
        )}

        <SectionItem
          label="SSN or ITIN"
          value={personalTaxpayerIdentificationNumber}
          maskedValue={maskedPersonalTaxpayerIdentificationNumber}
          isSensitive
        />
      </Section>
    </div>
  )
}
